// extracted by mini-css-extract-plugin
export var contentBody = "_9f-9";
export var headerImage = "_9f-2";
export var imageButton = "_9f-7";
export var imageButtonIcon = "_9f-8";
export var imageHeader = "_9f-4";
export var imageHeaderText = "_9f-5";
export var imageOverlay = "_9f-3";
export var imageTitle = "_9f-6";
export var imageWrapper = "_9f-1";
export var taskList = "_9f-a";
export var widget = "_9f-0";